export const primary = '#3869A0';
export const secondary = '#DA2640';
export const headings = '#1F1F30';
export const text = '#4A5568';
export const light_grey = '#F5F5F5';
export const white = '#FFFFFF';
export const support = '#97A2B9';
export const light_support = "rgba(74, 85, 104, 0.6)";
